import { useLocation } from "react-router-dom";
import { useRef, useEffect, useState } from "react";
import Summary from "./quality/Summary";
import Detail from "./quality/Detail";

/**
 * Wrapper component that keeps Summary mounted while navigating to Detail.
 * This prevents data loss and flickering when navigating between Summary and Detail views.
 */
export default function QualityWrapper() {
  const location = useLocation();
  
  // Check if we're on a detail page
  const isDetailView = location.pathname.includes('/measure/');
  
  // Track visibility changes to trigger data refresh when Summary becomes visible
  const wasDetailViewRef = useRef(isDetailView);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
  useEffect(() => {
    // When transitioning from detail view back to summary view, trigger a refresh
    if (wasDetailViewRef.current && !isDetailView) {
      console.log('[QualityWrapper] Summary becoming visible - triggering data refresh');
      setRefreshTrigger(prev => prev + 1);
    }
    wasDetailViewRef.current = isDetailView;
  }, [isDetailView]);
  
  // Extract measure ID from URL when on detail view
  // URL format: /programs/mips/gap-management/quality/measure/001:MIPS%20CQM
  // We need to extract "001:MIPS CQM" (decoded)
  const measureId = isDetailView 
    ? decodeURIComponent(location.pathname.split('/measure/')[1] || '')
    : null;
  
  console.log('[QualityWrapper] Current path:', location.pathname);
  console.log('[QualityWrapper] Is detail view:', isDetailView);
  console.log('[QualityWrapper] Measure ID:', measureId);
  
  return (
    <>
      {/* Summary is always mounted but hidden when viewing detail */}
      <div style={{ display: isDetailView ? 'none' : 'block' }}>
        <Summary refreshTrigger={refreshTrigger} />
      </div>
      
      {/* Render Detail directly when on detail view, passing the measure ID */}
      {isDetailView && measureId && <Detail measureIdFromUrl={measureId} />}
    </>
  );
}
